import { imagesList } from ".";

export const desktopThumbnail = [
  {
    imageName: imagesList.thumbnailDesktop1,
  },
  {
    imageName: imagesList.thumbnailDesktop2,
  },
  {
    imageName: imagesList.thumbnailDesktop3,
  },
  {
    imageName: imagesList.thumbnailDesktop4,
  },
  {
    imageName: imagesList.thumbnailDesktop5,
  },
];

export const mobileThumbnail = [
  {
    imageName: imagesList.thumbnailMobile1,
  },
  {
    imageName: imagesList.thumbnailMobile2,
  },
  {
    imageName: imagesList.thumbnailMobile3,
  },
];

export const lendingPartnersInfo = {
  "shivalik":{
    redressalPolicy: `${process.env.NEXT_PUBLIC_CDN_LINK}LendingPartners/Shivalik_Grievance%2BRedressal(2).pdf`,
  },
  "dmiFinance": {
    redressalPolicy: `https://www.dmifinance.in/grievance-redressal.php`,
  },
  "ugroCapital": {
    redressalPolicy: `https://www.ugrocapital.com/view-document/grievance-redressal-mechanism`,
    fairPracticesCode: `https://www.ugrocapital.com/fair-practices-code`,
  },
}